import { useState, useRef } from "react";
import './Accordion.css';

const AccordionItem = ({ item, active, onToggle }) => {
  const { title, content } = item;

  const contentEl = useRef();

  return (
    <li className={`accordion-item ${active ? "active" : ""}`}>
      <div className="accordion-btn-container">
       <button className={`accordion-btn ${active ? "active" : ""}`} onClick={onToggle}>
        <div className='title medium'>{title}</div>
       </button>
      </div>
      <div
        ref={contentEl}
        className="accordion-content-wrapper regular"
        style={
          active
            ? { height: contentEl.current.scrollHeight  }
            : { height: "0px" }
        }
      >
        <div className="accordion-content">
          {content}
        </div>
      </div>
    </li>
  );
};

const AccordionItems = ({items, multipleOpen}) => {

  const [openIndexes, setOpenIndexes] = useState([]);

  const handleToggle = (index) => {
    if (multipleOpen) {
      if (openIndexes.includes(index)) {
        setOpenIndexes(openIndexes.filter(i => i !== index));
      } else {
        setOpenIndexes([...openIndexes, index]);
      }
    } else {
      if (openIndexes.includes(index)) {
        setOpenIndexes([]);
      } else {
        setOpenIndexes([index]);
      }
    }
  };

  const isOpen = (index) => {
    return openIndexes.includes(index);
  }

  return (
    <ul className="accordion">
      {items.map((item, index) => (
        <AccordionItem
          onToggle={() => handleToggle(index)}
          active={isOpen(index)}
          key={index}
          item={item}
        />
      ))}
    </ul>
  );
};

const Accordion = ({header, items, multipleOpen = false}) => {
    return (
      <div className="accordion-container">
        <h3 className="accordion-heading large">{header}</h3>
        <AccordionItems items={items} multipleOpen={multipleOpen} />
        <a href='/financial-wellness-blog/faq/'>
        <button className='main'>Read more</button>
        </a>
      </div>
    );
  };

export default Accordion;